import styled from "styled-components";

export const ContainerWrapper = styled.div`
  display: flex;
  padding: 8px;
  overflow:hidden;
  justify-content: space-between;
`;
